import { z } from 'zod';

/** Création : exactement un de `userId` ou `groupRuleId`. */
export const createDocumentSpecificRuleSchema = z
  .object({
    userId: z.string().uuid().optional(),
    groupRuleId: z.string().uuid().optional(),
    dateStart: z.string().min(1, { message: 'Date de début requise' }),
    dateEnd: z
      .string()
      .optional()
      .transform((s) => (s === undefined || s === '' ? undefined : s)),
    redaction: z.boolean().default(false),
    validation: z.boolean().default(false),
    consultation: z.boolean().default(false),
    active: z.boolean().default(true),
  })
  .refine((d) => (d.userId ? 1 : 0) + (d.groupRuleId ? 1 : 0) === 1, {
    message: 'Choisissez un utilisateur ou un groupe (pas les deux, ni aucun).',
  });

export const updateDocumentSpecificRuleSchema = z.object({
  dateStart: z.string().min(1).optional(),
  dateEnd: z
    .string()
    .nullable()
    .optional()
    .transform((s) => (s === '' ? null : s)),
  redaction: z.boolean().optional(),
  validation: z.boolean().optional(),
  consultation: z.boolean().optional(),
  active: z.boolean().optional(),
});

export const documentSpecificRuleDtoSchema = z.object({
  id: z.string().uuid(),
  documentId: z.string().uuid(),
  dateStart: z.string().datetime(),
  dateEnd: z.string().datetime().nullable(),
  redaction: z.boolean(),
  validation: z.boolean(),
  consultation: z.boolean(),
  active: z.boolean(),
  assigneeType: z.enum(['user', 'group']),
  assigneeId: z.string().uuid(),
  assigneeLabel: z.string(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type CreateDocumentSpecificRuleInput = z.infer<typeof createDocumentSpecificRuleSchema>;
export type UpdateDocumentSpecificRuleInput = z.infer<typeof updateDocumentSpecificRuleSchema>;
export type DocumentSpecificRuleDto = z.infer<typeof documentSpecificRuleDtoSchema>;
